module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.createdMessage) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("Fakutra " + _vm._s(_vm.createdMessage) + " została dodana.")]) : _vm._e(), _vm._v(" "), (_vm.updateMessage) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("Fakutra " + _vm._s(_vm.updateMessage) + " została zmodyfikowana.")]) : _vm._e(), _vm._v(" "), _c('div', [_c('b-button', {
    attrs: {
      "variant": "default"
    },
    on: {
      "click": _vm.addNewInvoice
    }
  }, [_c('span', [_vm._v("Dodaj fakturę")]), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "plus"
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "createInvoiceModal",
    attrs: {
      "size": "lg",
      "hide-footer": "",
      "title": _vm.invoiceModalTitle
    }
  }, [(_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('form-factored-invoice', {
    ref: "formFactoredInvoice",
    attrs: {
      "handle-submit": _vm.handleSubmit,
      "currencyName": _vm.currencyName,
      "errors": _vm.errors,
      "values": _vm.item
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('b-row', [_c('b-col', [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "block": ""
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_c('span', [_vm._v("Anuluj")]), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "back"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "default",
      "block": ""
    },
    on: {
      "click": _vm.saveInvoice
    }
  }, [_c('span', [_vm._v("Zapisz")]), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "tick"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('invoice-list', {
    ref: "invoiceList",
    attrs: {
      "id": _vm.$route.params.id,
      "showEditButton": true,
      "editAction": _vm.editInvoice
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f11d9e6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/agreement/UpdateInvoice.vue
// module id = 809
// module chunks = 0